import { useEffect, useState } from 'react'
import { getReportDropGroupsAPI } from '../../services/dropdown'

function UseReportDropGroups(orgId) {
  const [options, setOptions] = useState([])
  const [rawData, setRawData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const resp = await getReportDropGroupsAPI({ orgId })
        if (!resp) return
        if (resp.status) {
          setRawData(resp.result)
          const newData = resp.result.map((d) => ({
            value: d?.groupId,
            label: `${d?.groupName} (${d?.group})`
          }))
          setOptions(newData)
        } else {
          setOptions([])
          setRawData([])
        }
      } finally {
        setLoading(false)
      }
    }

    if (orgId) {
      getData()
    }
  }, [orgId])

  return { options, rawData, loading }
}

export default UseReportDropGroups
